/**
 * Popup activity - composable functions
 *
 * * showAddActivityPopup() - shows the add activity popup
 * * showViewActivityPopup() - shows the view activity popup
 * * newActivity - a watchable object reference with the new activity that was added e.g.
 *
    watch(newActivity, (newItem) => {
      if (newItem) {
        activities.value.push(newItem);
      }
    });
 */
import { ref, onBeforeMount, onBeforeUnmount } from "vue";
import { Hub } from "aws-amplify/utils";
import { useAbility } from "@casl/vue";

// TODO add specific unit tests for this composable
/* v8 ignore start */
export default () => {
  const newActivity = ref(null);
  const updatedActivity = ref(null);
  const { can } = useAbility();

  let activityListenerCancel;

  onBeforeUnmount(() => {
    activityListenerCancel();
  });
  onBeforeMount(() => {
    activityListenerCancel = Hub.listen("activity", ({ payload }) => {
      switch (payload.event) {
        case "created":
          newActivity.value = payload.data;
          break;
        case "updated":
          updatedActivity.value = payload.data;
          break;
        default:
      }
    });
  });

  /**
   * Pass this function { rotaActivity: {...} } to show the add form with some defaults filled in
   *
   * @param {Object} data
   */
  function showAddActivityPopup(data) {
    if (!can("create", "rota.rota-activities")) {
      return false;
    }
    Hub.dispatch("popup-activity", {
      event: "add",
      data,
    });
    return true;
  }

  function showEditActivityPopup(data) {
    if (!can("update", "rota.rota-activities")) {
      return false;
    }
    Hub.dispatch("popup-activity", {
      event: "edit",
      data,
    });
    return true;
  }

  /**
   * Pass this function { rotaActivity: { id: xxx } } to show the rotaActivity object with
   * matching ID. The full activity object is not used.
   *
   * @param {Object} data
   */
  function showViewActivityPopup(data) {
    if (!can("read", "rota.rota-activities")) {
      return false;
    }
    Hub.dispatch("popup-activity", {
      event: "view",
      data,
    });
    return true;
  }

  return {
    showAddActivityPopup,
    showViewActivityPopup,
    showEditActivityPopup,
    newActivity, // we provide this so people can watch it for changes
    updatedActivity, // we provide this so people can watch it for changes
  };
};
/* v8 ignore stop */
